import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';

export type ButtonPreset = 'excel' | 'download' | 'search' | 'delete' | 'save' | 'exit' | 'print' | 'add' | 'refresh' | 'custom';

@Component({
  selector: 'aph-custom-buttons',
  templateUrl: './aph-custom-buttons.component.html',
  styleUrls: ['./aph-custom-buttons.component.scss']
})
export class AphCustomButtonsComponent implements OnInit, OnChanges {

  @Input() label: string = '';
  @Input() preset: ButtonPreset = 'custom';
  @Input() type: 'button' | 'submit' = 'button';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  
  @Input() customIcon: string = 'fa fa-cog';
  @Input() customColor: string = '';

  @Output() btnClick = new EventEmitter<Event>();

  public currentClass: string = '';
  public currentIcon: string = '';
  public customStyles: any = {};
  
  // Estado del hover
  public isHovered = false;

  private PRESETS_CONFIG: any = {
    excel:    { css: 'btn-outline-success', icon: 'fa fa-file-excel-o' },
    download: { css: 'btn-outline-info',    icon: 'fa fa-download' },
    search:   { css: 'btn-outline-primary', icon: 'fa fa-search' },
    delete:   { css: 'btn-outline-danger',  icon: 'fa fa-trash' },
    save:     { css: 'btn-outline-primary', icon: 'fa fa-save' },
    exit:     { css: 'btn-outline-danger',  icon: 'fa fa-arrow-left' },
    print:    { css: 'btn-outline-info', icon: 'fa fa-print' },
    add:      { css: 'btn-outline-primary', icon: 'fa fa-plus-circle' },
    refresh:  { css: 'btn-outline-primary uptop', icon: 'fa fa-sync' },
    custom:   { css: 'tn-custom-theme', icon: '' }
  };

  constructor() { }

  ngOnInit(): void {
    this.configureButton();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.configureButton();
  }

  // --- NUEVA FUNCIÓN PARA CONTROLAR EL HOVER ---
  onHover(state: boolean): void {
    // Si está deshabilitado o cargando, no hacemos efecto hover
    if (this.disabled || this.loading) return;
    
    this.isHovered = state;
    this.updateStyles(); // Recalculamos solo los estilos
  }

  private configureButton(): void {
    const config = this.PRESETS_CONFIG[this.preset];
    
    if (this.preset === 'custom') {
      this.currentIcon = this.customIcon;
      if(this.customColor.length > 0) {
        this.currentClass = `btn-outline-custom`; 
        this.updateStyles(); // Llamamos a la lógica de estilos
      } else {
        this.currentClass = `btn-custom-theme`;
      }
    } else {
      this.currentClass = config.css;
      this.currentIcon = config.icon;
      this.customStyles = {};
    }
  }

  // --- LÓGICA DE ESTILOS SEPARADA ---
  private updateStyles(): void {
    if (this.preset === 'custom' && this.customColor.length > 0) {
      this.customStyles = {
        'color': this.isHovered ? '#FFFFFF' : this.customColor,
        'border-color': this.customColor,
        'background-color': this.isHovered ? this.customColor : 'transparent'
      };
    }
  }

  // Bloqueamos el click si está disabled O si está cargando
  onClick(event: Event): void {
    if (!this.disabled && !this.loading) {
      this.btnClick.emit(event);
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}